<div class="row details-holder">
	<div class="col-md-6">
		<h4>Account Details</h4>
		<table class="info-table">
			<tr>
				<td style="width: 180px">Name of Account Holder:</td>
				<td>{{ accountDetails?.b_acc_holder }}</td>
			</tr>
			<tr>
				<td>Name of Bank:</td>
				<td>{{ accountDetails?.b_bank_name }}</td>
			</tr>
			<tr>
				<td>Branch Name:</td>
				<td>{{ accountDetails?.b_branch_name }}</td>
			</tr>
			<tr>
				<td>Branch Code:</td>
				<td>{{ accountDetails?.b_branch_code }}</td>
			</tr>
			<tr>
				<td>Account Number:</td>
				<td>{{ accountDetails?.b_acc_no }}</td>
			</tr>
			<tr>
				<td>Account Type:</td>
				<td>{{ accountDetails?.b_acc_type }}</td>
			</tr>
		</table>
	</div>
	<div class="col-md-3"></div>
	<div class="col-md-3"></div>
</div>
